import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { LoadingScreen } from 'src/components/loading-screen';
import MainDashboardLayout from 'src/layouts/dashboard/main-layout';
import OrganizationalHierarchyPage from 'src/pages/organizational-hierarchy-structure';
export const OrganizationalHierarchyRoutes = [
    {
        path: '/organizational-hierarchy' ,
        element: (
            <MainDashboardLayout>   
                <Suspense fallback={ <LoadingScreen /> }>
                    <Outlet />
                </Suspense>
            </MainDashboardLayout>
        ),
        children: [
            {
                element: <OrganizationalHierarchyPage />,
                index: true, 
            },
          
        ],
    },
];